import { Grid } from "@material-ui/core";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  fetchProjectTypes,
  fetchStates,
  fetchStyles
} from "../../redux/actions/filterActions";
import "./AddNewProject.css";

// Pages
import {
  fetchProjectDetails,
  fetchSubmissionTypes,
  initiateAddNewProject
} from "../../redux/actions/addProjectActions";
import { initLenderRequest, resetLenderRequest } from "../../redux/actions/lenderRequestActions";
import {
  isLenderRole,
  isProjectRole,
  isProjectStandardRole,
  isReadonlyRole,
  isTPORole
} from "../../redux/actions/userAction";
import { generateTempId } from "../shared/services/FileUploadService";
import SuccessPage from "../SuccessPage/SuccessPage";
import VerticalLinearStepper from "../VerticalLinearStepper/VerticalLinearStepper";
import AttachmentsPage from "./Pages/AttachmentsPage";
import CondoProjectPage from "./Pages/CondoProjectPage";
// import './Dropzone.css';

const AddNewProject = (props) => {
  if((!isProjectStandardRole() && !isLenderRole() && !isTPORole()) || isReadonlyRole()) {
     location.replace("/unauthorized");
     return null;
  }

  window.onscroll = function() {
    effects();
  };

  function effects() {}

  const [stepCount, setStepCount] = useState(0);
  const [tempId] = useState(() => !isProjectRole() ? generateTempId() : null);

  const steps = useMemo(() => {
    const steps = [
      "Add Project Details",
      "Final Confirmation"
    ];

    if (!isProjectRole()) {
      steps.splice(1, 0, "Attach Documents");
    }

    return steps;
  }, []);


  const incrementCounter = () => setStepCount(stepCount + 1);
  const decrementCounter = () => setStepCount(stepCount - 1);

  const projectId = isProjectRole()
    ? useSelector(store => store.addProjectReducer.projectId)
    : useSelector(store => store.lenderRequestReducer.projectInfo?.projectId);

  const projectType = isProjectRole()
    ? useSelector(store => store.addProjectReducer.condoProjectInfo?.type)
    : useSelector(store => store.lenderRequestReducer.projectInfo?.newProjectType);

  const dispatch = useDispatch();
  useEffect(() => {
    if ( props.match.params.type === 'new') {
      if (isProjectRole()) {
        dispatch(initiateAddNewProject());
      } else {
        dispatch(resetLenderRequest());
        dispatch(initLenderRequest("Lender Add Project"));
      }
    } else {
      dispatch(fetchProjectDetails())
    }
    dispatch(fetchStates());
    dispatch(fetchStyles());
    dispatch(fetchSubmissionTypes());
    dispatch(fetchProjectTypes());
  }, []);

  const getPage = () => {
    if (!stepCount) {
      return (
        <CondoProjectPage
          incrementCounter={incrementCounter}
        />
      );
    }

    if (stepCount === 1 && !isProjectRole()) {
      return (
        <AttachmentsPage
          tempId={tempId}
          incrementCounter={incrementCounter}
          decrementCounter={decrementCounter}
        />
      );
    }

    if (stepCount === steps.length - 1) {
      return (
        <SuccessPage
          project_id={projectId}
          project_type={projectType}
          requestTypeName={isProjectRole() ? "" : "Lender Add Project"}
          msg={isProjectRole()
            ? `A new project ${projectId} has been added!` 
            : `A new project ${projectId} was succesfully requested!`}
        />
      );
    }
      
    return "Empty name";
  };

  return (
    <Grid className="add-new-project" container>
      <Grid item xs={3} style={{ backgroundColor: "#F2F2F2" }}>
        <VerticalLinearStepper
          steps={steps}
          activeStep={stepCount}
        />
      </Grid>
      <Grid
        container
        item
        xs={9}
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        style={{ padding: "20px", border: "solid 1px black" }}
      >
        {getPage()}
      </Grid>
    </Grid>
  );
};

export default AddNewProject;
